import * as React from "react";
import AddEvidenceModal from "security-app/components/Investigations/plugin/shared/AddEvidenceModal";
import { useModalContext } from "common/contexts";
import DetectionChainModal from "./DetectionChainModal";
const DetectionChainsModals = () => {
  const { modal, setModal, entity, setEntity } = useModalContext();
  const onClose = () => {
    setModal(null);
    setEntity(null);
  };
  if (modal === "ADD-EVIDENCE") {
    return /* @__PURE__ */ React.createElement(AddEvidenceModal, { show: true, type: "events", ids: entity, onClose });
  }
  if (modal === "CREATE-CHAIN") {
    return /* @__PURE__ */ React.createElement(DetectionChainModal, { onClose });
  }
  if (modal === "EDIT-CHAIN") {
    return /* @__PURE__ */ React.createElement(DetectionChainModal, { onClose, chain: entity });
  }
  return null;
};
export default DetectionChainsModals;
